export const localStorageGet = (key) => localStorage.getItem(key);
export const localStorageSet = (key, value) => localStorage.setItem(key, value);
export const localStorageRemove = (key) => localStorage.removeItem(key);
